export const SERVER_ERROR = 'Server error. Please try again';
export const NOT_PERMITTED = 'Not permitted';
